import { INeoAction } from '../Actions.interface';
import { STATUS, REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { IProduct } from '../../Models/DTO/Product.models';
import { IErrorResponse } from '../../Models/DTO/Error.models';

export interface ProductState {
  productList: IProduct[];
  filteredProductList: IProduct[];
  loading: boolean;
  error: IErrorResponse | null;
}

const INITIAL: ProductState = {
  productList: [],
  filteredProductList: [],
  loading: false,
  error: null,
};

const mergeListsAndSort = (oldList: IProduct[], newList: IProduct[]) =>
  [
    ...oldList.filter(
      (oldProduct) => newList.findIndex((newProduct) => oldProduct.uuid === newProduct.uuid) === -1,
    ),
    ...newList,
  ].sort((a, b) => a.order - b.order);

export default (state: ProductState = INITIAL, action: INeoAction): ProductState => {
  const { status, payload, name } = action;

  if (name !== REQUEST_ACTIONS.PRODUCT_LIST) {
    return state;
  }

  switch (status) {
    case STATUS.SUCCESS:
      return {
        filteredProductList: Array.isArray(payload)
          ? payload
          : mergeListsAndSort(state.productList, [payload]),
        productList: Array.isArray(payload)
          ? mergeListsAndSort(state.productList, payload)
          : mergeListsAndSort(state.productList, [payload]),
        loading: false,
        error: null,
      };
    case STATUS.FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case STATUS.LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
  }

  return state;
};
